export default {
  // 该需求运行在评估app中，首页 =》 库存
  tabs: [{
      name: 'SelfInStock',
      path: '/ncStock/selfInStock',
      component: () => import('./src/stockOperate/selfInStock.vue'),
      meta: {
        // 自建单入库存
        title: '入库存',
        isMenu: true,
        keepAlive: true
      }
    },
    {
      name: 'StockList',
      path: '/ncStock/stockList',
      component: () => import('./src/stockList/stockList.vue'),
      meta: {
        title: '库存管理',
        isMenu: true,
        keepAlive: true
      }
    },
    {
      name: 'InStock',
      path: '/ncStock/inStock/:stockId/:carId',
      component: () => import('./src/stockOperate/inStock'),
      meta: {
        title: '入库',
        isMenu: true
      }
    },
    {
      name: 'OutStock',
      path: '/ncStock/outStock/:stockId/:carId',
      component: () => import('./src/stockOperate/outStock'),
      meta: {
        title: '出库',
        isMenu: true
      }
    },
    {
      name: 'BackStock',
      path: '/ncStock/backStock/:stockId/:carId',
      component: () => import('./src/stockOperate/backStock'),
      meta: {
        title: '回库',
        isMenu: true
      }
    },
    {
      name: 'BasicInformation',
      path: '/ncStock/basicInformation/:stockId/:carId',
      component: () => import('./src/basicInformation/stockDetail.vue'),
      meta: {
        title: '库存详情',
        isMenu: true
      }
    },
    {
      name: 'EditStockInformation',
      path: '/ncStock/editInfo/:stockCarInfoNo',
      component: () => import('./src/stockOperate/editStockInfo.vue'),
      meta: {
        title: '修改库存资料',
        isMenu: true
      }
    },
    {
      name: 'StockRecord',
      path: '/ncStock/stockRecord/:stockId/:carId',
      component: () => import('./src/stockOperate/stockRecord'),
      meta: {
        title: '库存记录',
        isMenu: true
      }
    },
    { // 整备功能不再使用，整备需要再pc上进行
      name: 'StockService',
      path: '/ncStock/stockService/:stockId/:carId',
      component: () => import('./src/carMaintenance/stockCarService'),
      meta: {
        title: '车辆整备',
        isMenu: true
      }
    },
    {
      name: 'EditService',
      path: '/ncStock/editService/:stockId/:carId/:serviceId/:serviceType/:type/:servicingName/:payment/:imgUrl',
      component: () => import('./src/carMaintenance/editService'),
      meta: {
        title: '编辑',
        isMenu: true
      }
    },
    {
      name: 'AddService',
      path: '/ncStock/addService/:stockId/:carId',
      component: () => import('./src/carMaintenance/addService'),
      meta: {
        title: '添加',
        isMenu: true
      }
    },
    { // 销售app 首页 =》 照片更新
      name: 'PhotoUpdateList',
      path: '/ncStock/photoUpdateList',
      component: () => import('./src/photoUpdate/photoUpdateList.vue'),
      meta: {
        title: '照片更新',
        isMenu: true
      }
    },
    {
      name: 'OrderSearchList',
      path: '/ncStock/orderSearchList',
      component: () => import('./src/photoUpdate/orderSearchList.vue'),
      meta: {
        title: '创建拍照任务',
        isMenu: true
      }
    },
    {
      name: 'photoOrderDetail',
      path: '/ncStock/photoOrderDetail/:photoWorkOrderId/:carId',
      component: () => import('./src/photoUpdate/photoOrderDetail.vue'),
      meta: {
        title: '详细信息',
        isMenu: true
      }
    },
    {
      name: 'vrPhotoDetail',
      path: '/ncStock/vrPhotoDetail/:vrPhotoUrl',
      component: () => import('./src/photoUpdate/vrPhotoDetail.vue'),
      meta: {
        title: 'VR照片详情展示',
        isMenu: true
      }
    },

    // ===========老版本 照片更新--灰度使用，以后可能会下掉=============
    // 入口： 销售app 首页 =》 照片更新
    {
      name: 'PhotoUpdateListOld',
      path: '/ncStock/photoUpdateListOld',
      component: () => import('./src/photoUpdate-old/photoUpdateList.vue'),
      meta: {
        title: '照片更新',
        isMenu: true
      }
    },
    {
      name: 'OrderSearchListOld',
      path: '/ncStock/orderSearchListOld',
      component: () => import('./src/photoUpdate-old/orderSearchList.vue'),
      meta: {
        title: '创建拍照任务',
        isMenu: true
      }
    },
    {
      name: 'photoOrderDetailOld',
      path: '/ncStock/photoOrderDetailOld/:photoWorkOrderId',
      component: () => import('./src/photoUpdate-old/photoOrderDetail.vue'),
      meta: {
        title: '详细信息',
        isMenu: true
      }
    },
    {
      name: 'vrPhotoDetailOld',
      path: '/ncStock/vrPhotoDetailOld/:vrPhotoUrl',
      component: () => import('./src/photoUpdate-old/vrPhotoDetail.vue'),
      meta: {
        title: 'VR照片详情展示',
        isMenu: true
      }
    },
    {
      name: 'FormalitiesStock',
      path: '/ncStock/formalitiesStock',
      component: () => import('./src/stockOperate/formalitiesStock.vue'),
      meta: {
        title: '手续',
        isMenu: true
      }
    }
  ]
}
